module.exports = __webpack_public_path__ + "files/9b465e02aa07dcf410500658d3685a1d.eot";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/droidserif-italic-webfont.eot
// module id = 382
// module chunks = 60